export default __webpack_public_path__ + "static/media/infinite.13d5b245.svg";